import React, { useContext } from 'react';
import { Link as RouterLink, useNavigate, useLocation } from 'react-router-dom';
import {
  Box,
  Flex,
  HStack,
  Link,
  Button,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Avatar,
  Text,
  IconButton,
  Badge,
  useColorMode
} from '@chakra-ui/react';
import { AuthContext } from '../context/AuthContext';
import { FaSun, FaMoon, FaUserCog } from 'react-icons/fa';

function Header() {
  const { user, logout, isAuthenticated, isAdmin, isReadOnly, pendingApproval } = useContext(AuthContext);
  const { colorMode, toggleColorMode } = useColorMode();
  const navigate = useNavigate();
  const location = useLocation();

  // Don't show navigation in the pending approval page
  const isPendingApprovalPage = location.pathname === '/pending-approval';

  return (
    <Box bg="teal.500" px={{ base: 4, md: 12 }}>
      <Flex h={16} alignItems="center" justifyContent="space-between" maxWidth="1400px" mx="auto">
        <HStack spacing={8} alignItems="center">
          <Link as={RouterLink} to="/" _hover={{ textDecoration: 'none' }}>
            <Text fontWeight="bold" fontSize="xl" color="white">
              Wishfin Env Manager
            </Text>
          </Link>
          {isAuthenticated && !isPendingApprovalPage && (
            <HStack as="nav" spacing={4} display={{ base: 'none', md: 'flex' }} color="white">
              <Link 
                as={RouterLink} 
                to="/" 
                onClick={(e) => {
                  e.preventDefault();
                  navigate('/', { replace: true });
                  window.location.href = '/';  // Force a full page reload to clear any state
                }}
              >
                Dashboard
              </Link>
              {isAdmin && (
                <Link as={RouterLink} to="/admin">Admin Panel</Link>
              )}
            </HStack>
          )}
        </HStack>

        <Flex alignItems="center">
          <IconButton
            mr={3}
            aria-label="Toggle color mode"
            icon={colorMode === 'light' ? <FaMoon /> : <FaSun />}
            onClick={toggleColorMode}
            size="sm"
            variant="ghost"
            color="white"
            _hover={{ bg: 'teal.600' }}
          />
          
          {user ? (
            <Menu>
              <MenuButton
                as={Button}
                rounded="full"
                variant="link"
                cursor="pointer"
                minW={0}
              >
                <Avatar size="sm" src={user?.picture} name={user?.name} />
              </MenuButton>
              <MenuList>
                <MenuItem fontWeight="bold">{user?.name}</MenuItem>
                <MenuItem fontSize="sm" color="gray.500">{user?.email}</MenuItem>
                {isAuthenticated && !isPendingApprovalPage && (
                  <>
                    <MenuItem>
                      <Badge colorScheme={isAdmin ? "purple" : "green"} mr={2}>
                        {isAdmin ? "Admin" : "User"}
                      </Badge>
                      {!isAdmin && (
                        <Badge colorScheme={isReadOnly ? "blue" : "orange"}>
                          {isReadOnly ? "Read Only" : "Read-Write"}
                        </Badge>
                      )}
                    </MenuItem>
                  </>
                )}
                {pendingApproval && (
                  <MenuItem>
                    <Badge colorScheme="yellow">Pending Approval</Badge>
                  </MenuItem>
                )}
                <MenuItem onClick={logout}>Logout</MenuItem>
              </MenuList>
            </Menu>
          ) : (
            <Button colorScheme="teal" variant="outline" color="white" borderColor="white" onClick={() => navigate('/login')}>
              Login
            </Button>
          )}
        </Flex>
      </Flex>
    </Box>
  );
}

export default Header;
